module.exports = __webpack_public_path__ + "228b0f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/world_map_dots.png
// module id = 826
// module chunks = 0 1 2 3 4 5